import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { GameServer } from '../../models/game-server.model';

@Injectable({
  providedIn: 'root',
})
export class GameServerService {
  private readonly http = inject(HttpClient);

  getGameServers(): Observable<GameServer[]> {
    return this.http.get<GameServer[]>(
      `${environment.apiUrl}/game-servers`,
    );
  }
}
